import request from '@/utils/request'
import {API} from './apiConfig'

export function getPersontInfo() {
	return request({
		url: API.getPersontInfo
	})
}

export function getPatientList(labelIds = '', pageNo = 1, pageSize = 10) {
	return request({
		method: 'get',
		url: API.getPatientList,
		params: {labels: labelIds, pageNo: pageNo, pageSize: pageSize}
	})
}

export function getDoctorQrCode() {
	return request({
		method: 'get',
		url: API.getDoctorQrCode
	})
}

export function checkDoctorAuthority() {
	return request({
		method: 'get',
		url: API.checkDoctorAuthority
	})
}

export function getPatientInfo(patientId = '') {
	return request({
		method: 'get',
		url: API.getPatientInfo,
		params: {patientId: patientId}
	})
}

// function
export function getDoctorLabelList() {
	return request({
		method: 'get',
		url: API.getDoctorLabelList
	})
}

export function updateDoctorLabel({content = '', labelId = '', option = ''}) {
	return request({
		url: API.updateDoctorLabel,
		method: 'post',
		params: {
			content,
			option,
			labelId
		}
	})
}

export function getConsultList({isRead = '', pageNo = 1, patientId = '', pageSize = 10}) {
	return request({
		method: 'get',
		url: API.getConsultList,
		params: {isRead: isRead, pageNo: pageNo, pageSize: pageSize, patientId: patientId}
	})
}

export function getPatientLabelList() {
	return request({
		method: 'get',
		url: API.getPatientLabelList
	})
}

export function updatePatientLabel({content = '', labelId = '', option = '', patientId = ''}) {
	return request({
		url: API.updatePatientLabel,
		method: 'post',
		params: {
			labelId,
			option,
			patientId,
			content
		}
	})
}

export function consultBaseInfo(consultId = '') {
	return request({
		url: API.consultBaseInfo,
		method: 'get',
		params: {consultationId: consultId}
	})
}

export function getConsultMsgList(consultId = '', pageNo = 1, pageSize = 10) {
	return request({
		url: API.getConsultMsgList,
		method: 'get',
		params: {consultationId: consultId, pageNo: pageNo, pageSize: pageSize}
	})
}

export function onDelConsult(id) {
	return request({
		url: API.onDelConsult,
		method: 'post',
		params: {
			consultationId: id
		}
	})
}

export function getConsultUnReadCount() {
	return request({
		url: API.getConsultUnReadCount,
		method: 'get'
	})
}

export function consultSubmit(consultId = '', file = '', message = '') {
	let params = new FormData()
	params.append('consultationId', consultId)
	message && params.append("message", message)
	file && params.append('image', file)
	return request({
		url: API.consultSubmit,
		method: 'post',
		data: params,
	})
}
